__turbopack_context__.v({
  "quiz-page": "QBJx3W_quiz-page",
  "quiz-page__button-icon": "QBJx3W_quiz-page__button-icon",
  "quiz-page__description-container": "QBJx3W_quiz-page__description-container",
  "quiz-page__text": "QBJx3W_quiz-page__text",
  "quiz-tabs-list": "QBJx3W_quiz-tabs-list",
  "topic-section": "QBJx3W_topic-section",
  "topic-section-container": "QBJx3W_topic-section-container",
  "topic-section-header": "QBJx3W_topic-section-header",
  "topic-section-header__heading": "QBJx3W_topic-section-header__heading",
  "topic-section-header__text": "QBJx3W_topic-section-header__text",
});
